<script>
  import { onMount, tick } from 'svelte';
  import { userid, clientID, isProduction } from './utils';
  import LED from './components/LED.svelte';

  export let user = null;
  export let currentUser = null;
  export let client = 'staging';
  export let production = false;
  let mounted = false;
  async function fetchClient() {
    mounted = false;
    await tick();
    mounted = true;
  }

  onMount(() => {
    if (user) {
      const parsedUser = JSON.parse(user);
      $clientID = client;
      $userid = parsedUser.access_token;
      $isProduction = production;
      mounted = true;
    }
  });
</script>

<main class="grid-builder-app">
  {#if mounted}
    <LED />
  {/if}

  {#if currentUser && currentUser.isShopBoxAdmin}
    <input bind:value={$clientID} type="text" name="client" id="client" />
    <button class="primary" on:click={fetchClient}>Load client id1</button>
  {/if}
</main>

<style>:global(*){box-sizing:border-box;margin:0}:global(html,body){font-family:Overpass,sans-serif;height:100%;width:100%}:global(h1,h2){font-family:Chivo,serif}main{position:relative;width:100%}:global(button){background:none;border:none;cursor:pointer}.grid-builder-app :global(button.icon){padding:0}.grid-builder-app :global(button.primary){background:#f64740;border:none;border-radius:2px;color:#fff;cursor:pointer;padding:14px 24px}input{border:1px solid #727178;border-radius:3px;margin-bottom:1em;padding:14px 6px}</style>
